module.exports = __webpack_public_path__ + "img/11_86.7fb1aee7.png";